export const setWebsocketConnect = (socket) => {
    return {
        type: 'WEBSOCKET_SET_CONNECT',
        payload: {
            socket,
        },
    };
};

export const setWebsocketStatus = (status) => {
    return {
        type: 'WEBSOCKET_SET_STATUS',
        payload: {
            status,
        },
    };
};

export const openWebsocketConnect = () => {
    return {
        type: 'WEBSOCKET_OPEN_CONNECT',
        payload: {},
    };
};

export const closeWebsocketConnect = () => {
    return {
        type: 'WEBSOCKET_CLOSE_CONNECT',
        payload: {},
    };
};
